import React from 'react'
import { Tooltip } from 'antd';
const bookGreen = require("Assets/test/bookGreen.svg").default;
const bookBlue = require("Assets/test/bookBlue.svg").default;
const bookMixed = require("Assets/test/bookMixed.svg").default;
const bookCoding = require("Assets/test/bookCoding.svg").default;

// refer: 0 Subjective, 1 Objective, 2 Mixed, 3 Coding
const ICONS = [
  { icon: bookBlue, title: "Subjective test" },
  { icon: bookGreen, title: "Objective test" },
  { icon: bookMixed, title: "Mixed test" },
  { icon: bookCoding, title: "Coding test" },
];

const IconAndVal = ({ val, refer }) => {
    const { icon: iconUrl, title } = ICONS[refer] || ICONS[0];
    return (
      <div>
        <Tooltip trigger={'hover'} placement='topRight' title={title}>
          <img
            style={{
              width: "18px",
              height: "18px",
            }}
            src={iconUrl}
            alt=""
          />
        </Tooltip>
        <span style={{ marginLeft: "5px" }}>{val}</span>
      </div>
    );
  };

export default IconAndVal